const app = {
    state: {
        current: 'Privacy'
    },
    mutations: {
        SET_PANEL: (state, nextPanel) => {
            state.current = nextPanel;
        }
    },
    actions: {
        SetPanel({ commit }, nextPanel) {
            commit('SET_PANEL', nextPanel)
            window.scrollTo(0,0);
        }
    }
}

export default app
